module.exports = __webpack_public_path__ + "static/lewandowski_main_42-51cf218002e6c08e90f0fd77f3849978.png";